import { render, staticRenderFns } from "./whenClass.vue?vue&type=template&id=31531155&scoped=true"
import script from "./whenClass.vue?vue&type=script&lang=js"
export * from "./whenClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31531155",
  null
  
)

export default component.exports